import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { PageAnalyticsPageProps } from '../src/components/PageAnalytics/PageAnalyticsPage.tsx';

export const PageAnalyticsPageLoader: LoadableType<PageAnalyticsPageProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsPageAnalyticsPage" */ '../src/components/PageAnalytics/PageAnalyticsPage.tsx'
			)
		).PageAnalyticsPage,
});
